import api from '@edu-fe/api'
import axios from 'axios'

export default {
  name: 'payment',
  getCourseData: api.create('/order/pay_course_info'),
  getCoupon: api.create('/coupon/order'),
  getGiftId: api.create('/course/gift/id'),
  getResource: api.create('/order/user_resource_coupon'),
  payByResource: api.create('/order/use_resource_coupon', { method: 'post', formData: true }),
  async getWxConfig (appId, url) {
    var row = ''
    await axios.get(`https://chenxidaily.auoktalk.com/api/chenxi/platform/js/ticket?appId=${appId}&url=${url}`).then(res => {
      const { data } = res
      row = data
    })
    console.log(row)
    return row

    // return api.create(`https://chenxidaily.auoktalk.com/api/chenxi/platform/js/ticket?appId=${appId}&url=${url}`)
  },
  // getWxConfig (url) {
  //   return api.create('/weixin/config', {
  //     method: 'post',
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded'
  //     },
  //     data: {
  //       url: url
  //     },
  //     transformRequest: [(data) => {
  //       let ret = ''

  //       for (let it in data) {
  //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  //       }
  //       return ret
  //     }]
  //   })
  // },
  payByStage: api.create('/order/stage', {
    method: 'post',
    formData: true
  }),
  getPaySuccessQRCode(courseId) {
    return api.create('/order/image?courseId=' + courseId)
  },
  checkOrderStatus: api.create('/order/check_status')
}
